import React from 'react'
import { Button } from 'is24-corecss'
import { useAppSelector } from '../../../../../../../../../../app/hooks'
import MultimediaButtonContent from '../common/MultimediaButtonContent'
import { getMultimediaButtonContent, MultimediaButtonTypes } from '../common/mediaButtonContentProvider'

import styles from '../common/MultimediaButtonCommon.module.css'
import { InitState } from '../../../../../../../../../../redux/reducers/root/initialState'
import { MultimediaButton } from './MultimediaButton'
import { ATTACHMENT_NUMBER_LIMIT } from '../../../../../../../../../../config'

const MultimediaButtonStateWrapper: React.FC<MultimediaButtonTypes> = ({
  allowedFileType,
  flowInformation,
  entryMode,
  isFloorPlan,
}) => {
  const { fileTypes, title, Icon } = getMultimediaButtonContent(allowedFileType)
  const attachmentsNumber = useAppSelector((state: InitState) => state.multimediaFeature.attachments?.length || 0)

  return attachmentsNumber < ATTACHMENT_NUMBER_LIMIT ? (
    <MultimediaButton
      allowedFileType={allowedFileType}
      isFloorPlan={isFloorPlan}
      flowInformation={flowInformation}
      entryMode={entryMode}
    />
  ) : (
    <DisabledButton icon={Icon} title={title} fileTypes={fileTypes} />
  )
}

function DisabledButton({
  icon,
  title,
  fileTypes,
}: {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  title: string
  fileTypes: string
}) {
  return (
    <Button className={`${styles.button} ${styles.buttonDisabled} cursor-pointer align-left border-radius-rounded`}>
      <MultimediaButtonContent Icon={icon} title={title} subtitle={fileTypes} />
    </Button>
  )
}

export default MultimediaButtonStateWrapper
